module.exports = __webpack_public_path__ + "sd.svg?60954d29a8a2f3f1ef0002c8566654b4";